import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import Form from '@/components/mixins/Form';
import utils from './utils';
import { DropDownController } from '@/services/request.service';

@Component
export default class FormStep2 extends Mixins(Form) {
  @Prop() public userInfo!: any;
  @Prop() public step1Info!: any;
  @Prop() public draftInfo!: any;
  // @Prop() public enquiryData!: any;

  public applicationStep2Form: any;
  public areaCode: string = '86';
  public areaCodeKey: number = 1;
  public verifyCodeTimer: number = 0;
  public verifyLoading: boolean = false;
  public nameOfDefault: boolean = false;
  public enNameOfDefault: boolean = false;
  public guardianNameOfDefault: boolean = false;
  public guardianEnNameOfDefault: boolean = false;
  public isOneParent: boolean = true;
  public isHasDefaultParent: boolean = false;
  public countryId: string = '';
  public guardianCountryId: string = '';
  public emergencyContactFlag: string = 'true';
  public sourceIsOther: boolean = false;
  public sourceId: number = 54;
  public isDraft: any = '';
  public utils = utils;
  public studentId: any = '';
  public draftId: any = '';
  public isSource: boolean = false;
  public studentSource: boolean = false;
  public teacherSource: boolean = false;
  public value: any = ''
  public dataSource: any = []
  public beforeCreate(): void {
    this.applicationStep2Form = this.$form.createForm(this);
  }

  public created(): void {
    this.isDraft = this.$route.query.isDraft;
  }

  public handlePhoneOfCountryChange(value: any, option: any): void {
    this.areaCodeKey = value ? value : 1;
    const res: any = this.$store.state.countryList.filter((item: any) => item.key === value);
    if (res.length > 0) {
      this.areaCode = res[0].extraValue;
    }
  }

  public changeIsEmergencyContact(e: any): void {
    this.emergencyContactFlag = e.target.value;
  }

  @Watch('userInfo', { immediate: true })
  public setContent(): void {
    if (!this.isDraft) {
      this.$nextTick(() => {
        this.draftId = this.userInfo.draftId;
        this.studentId = this.userInfo.studentId;
        this.setFormContent(this.userInfo);
      });
    }
  }

  @Watch('draftInfo', { immediate: true })
  public setDraftContent(): void {
    if (this.draftInfo && this.draftInfo.parentInfo) {
      this.$nextTick(() => {
        this.setFormContent(this.draftInfo.parentInfo);
        this.draftId = this.draftInfo.draftId;
        this.studentId = this.draftInfo.studentId;
      });
    }
  }
  // @Watch('enquiryData', { immediate: false })
  // public getIsSource(){
  //   if (this.enquiryData && this.enquiryData.sourceId && this.$route.query.studentId) {
  //     this.isSource = true;
  //   } else {
  //     this.isSource = false;
  //   }
  // }
  public getDraftContent(e: Event): any {
    e.preventDefault();
    const values = this.applicationStep2Form.getFieldsValue();
    const data: any = this.step1Info;

    data.siblingDrafts = this.step1Info.siblings;
    data.parentDraftInfo = values;
    data.parentDraftInfo.areaCode = this.areaCode;
    data.parentDraftInfo.guardianDraftRequest = !this.isOneParent ? utils.formatGuardianData(values) : null;
    data.parentDraftInfo.emergencyContactDraftRequest =
      values.emergencyContactFlag === 'false' ? utils.formatEmergencyData(values) : null;
    return data;
  }

  public setFormContent(userInfo: any) { }

  public addParent(flag: boolean): void {
    this.isOneParent = flag;
  }

  public handleSourceChange(value: number): void {
    this.sourceId = value;
    this.sourceIsOther = this.config[this.school].showResourceExtraValue.includes(value) ? true : false;
    this.teacherSource = value === 1280 ? true : false
    this.studentSource = value === 741 ? true : false
  }
  public onSelect() {

  }
  public onSearch(searchText: any) {
    if (this.teacherSource === true) {
      DropDownController.getMembersByName(searchText).then(res => {
        //   this.data = res && res.data ? res.data : {};
        // for (var i in this.data) {
        //   this.studentList.push(this.data[i].name);
        // }
        if (res) {
          this.dataSource = []
          res.data.map(item => {
            if (item.enValue) {
              this.dataSource.push(item.value + item.enValue)
            } else {
              this.dataSource.push(item.value)
            }
          })
        }
        // this.dataSource = res.data
      })
    }
    if (this.studentSource === true) {
      DropDownController.getStudentsByName(searchText).then(res => {
        if (res) {
          this.dataSource = []
          res.data.map(item => {
            if (item.enValue) {
              this.dataSource.push(item.value + item.enValue)
            } else {
              this.dataSource.push(item.value)
            }
          })
        }
      })
    }
  }
  public onChange(value: any) {

  }
  public backToPrevStep(e: Event): void {
    e.preventDefault();
    const values = this.applicationStep2Form.getFieldsValue();
    values.areaCode = this.areaCode;
    this.$emit('changeStep', 'prev', 'step2', values);
  }
}
